/**
 * @generated SignedSource<<deb206af77426f16c1815b4eb3c77dc4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderStatus = "ACCEPTED" | "CANCELED" | "CREATED" | "EXPIRED" | "FAILED" | "FINISHED";
export type AcceptOrderInput = {
  id: string;
};
export type AcceptOrderMutation$variables = {
  input?: AcceptOrderInput | null | undefined;
};
export type AcceptOrderMutation$data = {
  readonly acceptOrder: {
    readonly id: string;
    readonly status: OrderStatus;
  } | null | undefined;
};
export type AcceptOrderMutation = {
  response: AcceptOrderMutation$data;
  variables: AcceptOrderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "acceptOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptOrderMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptOrderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a106ebf5b477801a411c235eb7ea8d1f",
    "id": null,
    "metadata": {},
    "name": "AcceptOrderMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptOrderMutation(\n  $input: AcceptOrderInput\n) {\n  acceptOrder(input: $input) {\n    id\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "aa00d60810caced7743ee2e56aec9f6e";

export default node;
